import React, { useEffect } from "react";

const FACEBOOK_CLIENT_ID = "4196547247300935";

const FacebookLoginPopup: React.FC = () => {
  useEffect(() => {
    // Immediately redirect to Facebook OAuth URL for authorization code flow
    const redirectUri = "https://webchat.supportedbusiness.com/auth/callback";
    const clientId = new URLSearchParams(window.location.search).get("clientId") || "";
    localStorage.setItem('ClientID', clientId);
    
    const authUrl = new URL("https://www.facebook.com/v19.0/dialog/oauth");
    authUrl.searchParams.set("client_id", FACEBOOK_CLIENT_ID);
    authUrl.searchParams.set("redirect_uri", redirectUri);
    authUrl.searchParams.set("response_type", "code");
    authUrl.searchParams.set("scope", "email,public_profile");
    authUrl.searchParams.set("state", "facebook_login"); // Add state for security
    
    // Redirect to Facebook OAuth consent screen
    window.location.href = authUrl.toString();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1877F2 0%, #42A5F5 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(24, 119, 242, 0.20)",
          padding: "40px 32px 32px 32px",
          minWidth: 340,
          maxWidth: 400,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Facebook Logo */}
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom: 16}}>
          <rect width="48" height="48" rx="12" fill="#1877F2"/>
          <path d="M26.0615 25.0613L26.5842 21.3613H22.9956V19.0613C22.9956 18.0302 23.4956 17.0223 25.0456 17.0223H26.7349V13.9013C26.7349 13.9013 25.3055 13.6613 23.9355 13.6613C21.0815 13.6613 19.2456 15.3613 19.2456 18.6613V21.3613H15.9375V25.0613H19.2456V34.8613H22.9956V25.0613H26.0615Z" fill="white"/>
        </svg>
        
        <h2 style={{ color: "#1877F2", margin: 0, fontWeight: 700, fontSize: 24, letterSpacing: 0.5 }}>Redirecting to Facebook...</h2>
        <p style={{ color: "#666", margin: "12px 0 24px 0", fontSize: 15, textAlign: "center" }}>
          Please wait while we redirect you to Facebook for secure authentication.
        </p>
        
        {/* Loading spinner */}
        <div style={{
          width: 40,
          height: 40,
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #1877F2",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default FacebookLoginPopup;